module.exports = __webpack_public_path__ + "static/img/rs_js_17.8bc576e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rs/rs_js_17.png
// module id = 14JR
// module chunks = 1